import FoundersAboutSection from "@/components/FoundersAbout";
import FoundersHeroSection from "@/components/FoundersHero";
import FoundersPortfolioSection from "@/components/FoundersPortfolio";
import FoundersSocialProofSection from "@/components/FoundersSocialProof";

const Founder = () => {
    return (<>
        <FoundersHeroSection />
        <FoundersAboutSection />
        <FoundersPortfolioSection />
        <FoundersSocialProofSection/>
    </>);
}

export default Founder;